import { render, staticRenderFns } from "./TagsForm.vue?vue&type=template&id=0e87906b&scoped=true"
import script from "./TagsForm.vue?vue&type=script&lang=js"
export * from "./TagsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e87906b",
  null
  
)

export default component.exports